// extracted by mini-css-extract-plugin
module.exports = {"primary":"_1lW0ADVkdE3X_49_3sA8_O"};